import React, { useState, useEffect } from "react";
import generateTableContent from "../../util/generateTableContent";
import request from "../../api/paymentRequests";
import Drawer from "../../components/Drawer";
import Table from "../../components/Table";
import PaymentsForm from "../../components/Payments/PaymentsForm";

const Payments = () => {
    const [payments, setPayments] = useState([]);
    const [render, setRender] = useState(false);
    const renderData = { render, setRender };
    const drawerForm = <PaymentsForm renderData={renderData} />;

    handleCharges();

    const columns = [
        { displayName: "", key: "collapse", position: 0 },
        { displayName: "Fecha", key: "date", position: 1 },
        { displayName: "N° Comprobante", key: "paymentPdfId", position: 2 },
        { displayName: "Proveedor", key: "provider", position: 3 },
        { displayName: "Importe", key: "total", position: 4 },
        { displayName: "Observación", key: "paymentComment", position: 5 },
        { displayName: "Acción", key: "action", position: 6 },
    ];

    const tableContent = generateTableContent(
        columns,
        payments,
        renderData,
        request,
        drawerForm,
    );

    return (
        <div>
            <Drawer activationMessage="Cargar Pagos" size="xxl">
                {drawerForm}
            </Drawer>
            <Table tableContent={tableContent} />
        </div>
    );

    function handleCharges() {
        useEffect(() => {
            (async () => {
                const payments = await request.getRecords();
                setPayments(payments);
            })();
        }, [render]);
    }
};

export default Payments;
